const styles = (theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },

  loader: {
    margin: theme.spacing(4),
  },

  empty: {
    margin: theme.spacing(4),
  },
});

export default styles;
